module.exports = __webpack_public_path__ + "img/tokopedia.4b3c2acb.svg";